// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Kod błędu:",
    "error.search": "Przeszukaj naszą bazę wiedzy, aby dowiedzieć się więcej",
    dismiss: "odrzuć",
    "installation.title": "",
    "cancelation.button": "Anuluj",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Inicjalizacja zakończona niepowodzeniem",
      description:
        "Nie udało nam się wyrenderować strony. Prosimy o kontakt z działem wsparcia.",
    },
    "EOS-UI-UE": {
      title: "Coś poszło nie tak.",
      description: "Coś poszło nie tak. Prosimy o kontakt z działem wsparcia.",
    },
    "EOS-IN-BC": {
      title: "Instalacja zakończona niepowodzeniem",
      description:
        "Nie udało nam się pokazać postępów instalacji. Prosimy o kontakt z działem wsparcia.",
    },
    "EOS-IN-UE": {
      title: "Instalacja zakończona niepowodzeniem",
      description: "Coś poszło nie tak. Prosimy o kontakt z działem wsparcia.",
    },
    "EOS-IN-FF": {
      title: "Instalacja zakończona niepowodzeniem",
      description:
        "Nie udało nam się połączyć z usługami Epic Online Services. Prosimy o kontakt z działem wsparcia.",
    },
    "EOS-IN-FF-*": {
      title: "Instalacja zakończona niepowodzeniem",
      description:
        "Nie udało nam się wysłać żądania do usług Epic Online Services. Prosimy o kontakt z działem wsparcia.",
    },
    fallback: {
      title: "Coś poszło nie tak.",
      description: "Coś poszło nie tak. Prosimy o kontakt z działem wsparcia.",
    },
  },
};
